module.exports = __webpack_public_path__ + "img/staking_time_btn_hover.2334d5c8.png";